<template>
  <div>
    <el-page-header @back="$router.push('../.')" :content="title" />
    <el-row :gutter="10">
      <el-col :span="12">
        <el-card style="min-height: 500px">
          <div slot="header">修改角色</div>
          <el-form
            ref="roleForm"
            v-model="roleForm"
            label-width="80px"
          >
            <el-form-item label="工种" prop="role" >
              <el-select
                style="width: 75%"
                v-model="roleForm.role"
                 placeholder="请选择工种"
              >
                <el-option
                  v-for="(item, index) in workOption"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>

            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="roleSave">保存角色信息</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card style="min-height: 500px">
          <div slot="header">员工基础信息</div>
          <el-form
            ref="employeeFrom"
            :model="employeeFrom"
            :rules="rules"
            size="small"
            label-width="80px"
          >
            <el-row>
              <el-form-item
                 label="所属公司"
                 style="width: 75%"
              >
                <el-input
                  v-model="employeeFrom.enterpriseName"
                  :rows="6"
                  disabled
                />
              </el-form-item>
              <el-form-item label="姓名" prop="name" style="width: 75%">
                <el-input
                  v-model="employeeFrom.name"
                  :rows="6"
                  maxlength="30"
                  placeholder="请输入员工姓名"
                />
              </el-form-item>
              <el-form-item label="手机号码" prop="phone" style="width: 75%">
                <el-input
                  type="text"
                  oninput="value=value.replace(/\D/g,'')"
                  placeholder="请输入数字"
                  v-model="employeeFrom.phone"
                  maxlength="11"
                >
                </el-input>
              </el-form-item>
              <el-form-item
                label="密码"
                style="width: 75%"
              >
                <el-input
                  v-model="employeeFrom.password"
                  :rows="6"
                  maxlength="30"
                  placeholder="请输入密码"
                />
              </el-form-item>
              <el-form-item label="">
                <el-button type="primary" @click="save">保存个人信息</el-button>
              </el-form-item>
            </el-row>
         </el-form>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
  import { personUpdateRole, userInfo, personUpdate } from '@/api/person.js'
  export default {
    name:'PersonEditor',
    data() {
      return {
        employeeFrom: {
          id: undefined,
          enterpriseName: '',
          entrId: '',
          name: '',
          password: '',
          sex: '',
          role: '', //角色
          status: '',
          phone: '',
        },
        roleForm: {
          role: '',
        },
        workOption: [
          {
            label: '工人',
            value: 'product-executor',
          },
          {
            label: '管理',
            value: 'product-manager',
          },
        ],
        rules: {
          name: [
            { required: true, message: '员工名称不能为空', trigger: 'change' }
          ],
          role: [
            { required: true, message: '请选择工种', trigger: 'change' }
          ],
          phone: [
            { required: true, message: '手机号不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    computed:{
      title(){
        return '编辑员工'
      }
    },
    mounted() {
      this.userInfoDateGet()
    },
    methods:{
      save() {
        this.$refs.employeeFrom.validate((valid)=>{
          if(valid){
            this.employeeFrom.enterpriseId = this.enterPriseId
            personUpdate(this.employeeFrom).then((data) => {
              this.employeeName = null
              this.$router.push('../list')
              this.$message.success('提交成功')
            })
          }
        })
      },
      clearFrom() {},
      userInfoDateGet() {
        let id=this.$route.params.id
        userInfo(id).then(data=>{
          this.employeeFrom.enterpriseName=this.$store.getters.currentEnterprise.name
          this.employeeFrom.id=data.data.id
          this.employeeFrom.name=data.data.name
          this.employeeFrom.phone=data.data.phone
        })
      },
      roleSave() {
        personUpdateRole(this.employeeFrom.id, {
          entrId: this.enterpriseId,
          id: this.employeeFrom.id,
          role: this.roleForm.role,
        }).then((data) => {
          this.$message.success(data.message)
        })
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/meta/person/PersonEditor.vue